import { useLocation, useNavigate } from "react-router-dom";

import {
    List,
    Edit,
    Datagrid,
    SimpleForm,
    TextInput,
    EditButton,
    TextField,
    SelectArrayInput,
    FunctionField,
    ReferenceArrayField,
    SingleFieldList,
    ReferenceArrayInput,
    FormDataConsumer,
} from "react-admin";

import LargePagination from "../core/LargePagination";
import { LVEditToolbar } from "../core/toolbars";
import AssignClientChart from "../custom/AssignClientChartButton";

import Filter from "../core/Filter";
import buildNewUrl from "../../helpers/buildNewUrl";

const BreakField = () => <br />;

export const LineRoleGroupList = ({ ...props }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <>
            <Filter
                filterKeys={["siteGroupName", "lineName"]}
                labels={{ siteGroupName: "Site Group", lineName: "Line Name" }}
                onChange={(newFilterParams) => {
                    navigate(buildNewUrl(location, newFilterParams, true));
                }}
            />

            <List title="All lines" perPage={500} pagination={<LargePagination />} {...props}>
                <Datagrid bulkActionButtons={false}>
                    <TextField source="id" />
                    <TextField source="lineName" />
                    <FunctionField
                        label="Site Groups"
                        render={(record) =>
                            record.sections.flatMap((section) =>
                                section.SiteGroups.map((siteGroup) => (
                                    <div
                                        key={`line-site-groups-${record.id}-${section.sectionId}-${siteGroup.siteGroupId}`}
                                    >
                                        {siteGroup.name}
                                    </div>
                                ))
                            )
                        }
                    />
                    <ReferenceArrayField label="Role Groups" source="rolegroupids" reference="portal/roleGroups">
                        <SingleFieldList linkType={false}>
                            <FunctionField
                                style={{ flex: "100%" }}
                                label=""
                                render={(roleGroup) => (
                                    <div key={`line-role-groups-${roleGroup.roleGroupId}`}>{roleGroup.name}</div>
                                )}
                            />
                        </SingleFieldList>
                    </ReferenceArrayField>
                    <EditButton />
                </Datagrid>
            </List>
        </>
    );
};

const classes = {
    textInput: {
        display: "flex",
        width: "20rem",
    },
};

const LineTitle = ({ record }) => {
    return <span>Line {record ? `"${record.lineName}"` : ""}</span>;
};

// http://ziptasticapi.com/47122  NOTE: we can use this in the future to get a city/state

const validateLineRoleGroupCreation = (values) => {
    const errors = {};

    if (!values.rolegroupids) {
        errors.rolegroupids = "The Role Group List field is required";
    }

    return errors;
};

export const LineRoleGroupEdit = (props) => {
    return (
        <Edit title={<LineTitle />} {...props}>
            <SimpleForm validate={validateLineRoleGroupCreation} toolbar={<LVEditToolbar deleteButton={false} />}>
                <TextInput disabled label="Line" source="lineName" sx={classes.textInput} />

                <ReferenceArrayInput
                    label="Role Group List"
                    source="rolegroupids"
                    reference="portal/roleGroups"
                    style={{ width: "100%" }}
                >
                    <SelectArrayInput optionText={(rg) => (rg ? rg.id + ": " + rg.name : "")} />
                </ReferenceArrayInput>

                <FormDataConsumer>
                    {({ formData }) => (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontFamily: "Roboto",
                                position: "relative",
                                top: "-.5rem",
                            }}
                        >
                            <AssignClientChart
                                getEntityIds={() => {
                                    return { lineIds: [formData.id] };
                                }}
                            />
                            <span style={{ marginLeft: ".5rem" }}>Assign Client Chart</span>
                        </div>
                    )}
                </FormDataConsumer>

                <BreakField />
            </SimpleForm>
        </Edit>
    );
};
